import { render, staticRenderFns } from "./Devtools.vue?vue&type=template&id=c98663d2&"
import script from "./Devtools.vue?vue&type=script&lang=ts&"
export * from "./Devtools.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports